export function getRetryUnprocessedIncomingEmailsInput(organisationId, flowId) {
	return {
		organisation_id: organisationId,
		flow_id: flowId,
		unprocessed: true,
	};
}
